export default {
  PENDING: 'pending',
  FAILED: 'failed',
  RESOLVED: 'resolved',
};



// WEBPACK FOOTER //
// ./src/widget/constants/ulrs-cache-status.js